import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const binaryDrawerAction: UseResourceDrawerOpenDrawerArgs<'Binary'>['action'] = ({
  model,
}) => ({
  label: 'Document',
  title: model.title,
  enableDismissAndReadActions: true,
  content: {
    body: (
      // TODO: Implement this to match `documentReferenceDrawerAction but using `binaryId` as the entrypoint;
      //       see `binaryDrawerAction` for inspiration
      <div className={tw`flex flex-col gap-5`}>TODO</div>
    ),
  },
});
